<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">{{ title }}</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <form [formGroup]="form" class="dialog-form">
    <div class="field-row">
      <div class="field">
        <span class="field-label">Premises</span>
        <select class="text-box-active" formControlName="premisesId">
          @for(p of data.premisesList; track p.premisesId){ <option [value]="p.premisesId">{{ p.name }}</option> }
        </select>
      </div>
      <div class="field">
        <span class="field-label">Type</span>
        <select class="text-box-active" formControlName="type">
          <option value="INTERNAL">Internal</option>
          <option value="EXTERNAL">External</option>
        </select>
      </div>
      @if(!isEdit){
      <div class="field">
        <span class="field-label">Status</span>
        <select class="text-box-active" formControlName="status">
          <option value="ACTIVE">Active</option>
          <option value="INACTIVE">Inactive</option>
        </select>
      </div>
      }
    </div>
    <div class="field-row">
      <div class="field"><span class="field-label">Name</span><input class="text-box-active" formControlName="name" /></div>
      <div class="field"><span class="field-label">Short name</span><input class="text-box-active" formControlName="abbrevName" /></div>
    </div>
    @if(isEdit){
    <p class="dialog-note">Use Activate / Deactivate on the list to change the status (it records a reason).</p>
    }
    <div class="field-row">
      <div class="field"><span class="field-label">Address</span><input class="text-box-active" formControlName="address" /></div>
    </div>
    <div class="field-row">
      <div class="field"><span class="field-label">Category</span><input class="text-box-active" formControlName="category" placeholder="e.g. GUESTHOUSE / DORMITORY" /></div>
      <div class="field"><span class="field-label">Floors</span><input class="text-box-active" type="number" formControlName="floorCount" /></div>
      <div class="field"><span class="field-label">Total capacity</span><input class="text-box-active" type="number" formControlName="totalCapacity" /></div>
    </div>
    <div class="field-row">
      <div class="field"><span class="field-label">Contact number</span><input class="text-box-active" type="number" formControlName="contactNumber" /></div>
      <div class="field"><span class="field-label">Alternate contact</span><input class="text-box-active" type="number" formControlName="altContactNumber" /></div>
      <div class="field"><span class="field-label">GST number</span><input class="text-box-active" formControlName="gstNumber" /></div>
    </div>
    <div class="flag-row">
      <label class="flag"><input type="checkbox" formControlName="isUtsav" /> Used for utsav stays</label>
    </div>
    <div class="field-row">
      <div class="field"><span class="field-label">Comments</span><input class="text-box-active" formControlName="comments" /></div>
    </div>
    <p class="dialog-note">Only INTERNAL and ACTIVE guest houses take part in bookings.</p>
  </form>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Cancel</button>
    <button type="button" class="ac-primary-btn" (click)="submit()">{{ isEdit ? 'Save' : 'Add' }}</button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
